module.exports = __webpack_public_path__ + "static/media/bell.fcfbcdcc.svg";